module.exports = __webpack_public_path__ + "img/photo_johan.169c45df.png";